<div class="tabs">
  <nav
    mat-tab-nav-bar
    class="themed-tab-nav">
    <a
      mat-tab-link
      *ngFor="let tab of tabs"
      (click)="switchTab(tab.value)"
      [active]="(tabParam$ | async) == tab.value"
      [attr.data-cy]="'tab-' + tab.value">
      <mat-icon
        [svgIcon]="tab.svgIcon"
        class="size-20"></mat-icon>
      {{ tab.label | i18n | titlecase }}
    </a>
  </nav>
</div>
<app-date-range-select
  class="date-range-select"
  [chips]="dateRangeChips"
  useQueryParam="range"
  subscribeParams
  data-cy="date-range-select"></app-date-range-select>

<mat-form-field class="light-form-field">
  <mat-label>{{ "search" | i18n | titlecase }}</mat-label>
  <input
    matInput
    [ngModel]="searchParam$ | async"
    (ngModelChange)="mergeQueryParams({ searchText: $event })"
    name="searchText"
    data-cy="employment-search-input" />
  <button
    mat-button
    matSuffix
    mat-icon-button
    aria-label="Search"
    (click)="$event.stopPropagation()">
    <mat-icon svgIcon="magnify"></mat-icon>
  </button>
</mat-form-field>
<div class="flex justify-end filter-row">
  <div class="employments-index__show-canceled-jobs-checkbox">
    <mat-checkbox
      [ngModel]="showCanceledJobs"
      [checked]="showCanceledJobs"
      name="showCanceledEmployments"
      data-cy="show-canceled-employments-checkbox"
      (change)="toggleShowCanceledJobs($event)"
      *ngIf="(tabParam$ | async) === 'ARCHIVED'">
      {{ "showCanceledEmployments" | i18n }}
    </mat-checkbox>
  </div>
  <div class="flex-spacer"></div>
  <button
    mat-button
    class="save-filter-button"
    (click)="saveDefaultFilter()"
    data-cy="save-filter-button">
    <div class="filter-actions-button-content">
      <mat-icon svgIcon="save"></mat-icon>
      {{ "saveDefaultFilter" | i18n }}
    </div>
  </button>
</div>
<div
  *ngIf="((employments$ | async)?.length || -1) >= limit"
  class="too-many-employments">
  <mat-icon svgIcon="information-outline"></mat-icon>
  {{ "tooManyEmployments" | i18n: { limit: limit.toString() } }}
</div>
<div
  class="employments-list"
  data-cy="dispo-employments-list">
  <ng-container
    *ngIf="($isLoadingEmployments | async) && !(employments$ | async)?.length">
    <p>{{ "loadingEmployments" | i18n }}</p>
    <mat-spinner
      class="loading-spinner"
      data-cy="loading-employments-spinner"
      diameter="24"></mat-spinner>
  </ng-container>
  <ng-container
    *ngIf="!($isLoadingEmployments | async) && !(employments$ | async)?.length">
    <p style="height: 100%">
      {{ "noEmploymentsFound" | i18n }}
    </p>
  </ng-container>
  <ng-container
    *ngFor="
      let employment of employments$ | async;
      let i = index;
      trackBy: trackById
    ">
    <app-employment-list-item
      *ngIf="(loadedEmploymentIds$ | async)?.has(employment._id); else skeleton"
      [routerLink]="'/temp-work/employments/' + employment._id"
      [employment]="employment"></app-employment-list-item>
    <ng-template #skeleton>
      <app-dispo-employment-list-item-skeleton
        [showSkeleton]="i < 5"></app-dispo-employment-list-item-skeleton>
    </ng-template>
  </ng-container>
</div>

<div class="floating-actions-bar">
  <button
    class="primary-pill-button icon-left big-fab"
    routerLink="/temp-work/employments/new"
    type="button"
    data-cy="create-employment-button">
    <mat-icon svgIcon="add-circle-plus"></mat-icon>
    {{ "createNewEmployment" | i18n | titlecase }}
  </button>
</div>
